




















import {auth} from'../firebaseConfig';
import { Component, Vue } from 'vue-property-decorator';
import Topbar from '@/components/Topbar.vue';
import router from '../router';

@Component({
  components: {
    Topbar
  }
})
export default class Auth extends Vue {
    
    name: string = '';
    user: any = {};
    photo:string = '';
    userId: string = '';
    email: string = '';
    
    created(){
        this.user = auth.currentUser;
        this.name = this.user.displayName; 
        this.email = this.user.email; 
        this.photo = this.user.photoURL; 
        this.userId = this.user.uid; 
    }

    logOut() { 
        auth.signOut().then(()=> {
            this.$router.push('/');
          
        }).catch((error)=> {
            // An error happened.
           
        });  
    } 
};
